export default (contacts) => contacts.filter(({isInternal}) => isInternal);
